import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

// Kill the initial splash the moment React starts rendering so the user
// never sees a black flash or the SEO fallback text.
requestAnimationFrame(() => {
  const s = document.getElementById("tj-splash");
  if (s) { s.style.transition = "opacity .2s"; s.style.opacity = "0"; setTimeout(() => s.remove(), 250); }
});

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
